import {Card} from '@material-ui/core';
import React, {useContext} from 'react';
import Tabs from './Tabs';
import {ThemeContext} from '../../../../themes/ThemeProvider';

const DMRecordGroup = () => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();

  return (
    <>
      <Card className={` ${classes.cardBordernoneStyles} mb-0`} elevation={0}>
        <Tabs />
      </Card>
    </>
  );
};

export default DMRecordGroup;
